import React from 'react';
import _ from 'lodash';

import {
  useSaveTriageReasonsMutation,
  useTriageReasonsWidgetQuery
} from 'generated/graphql';

import * as types from './types';



export interface IData {
  formState: types.IFormState;
}

export function useQuery(storeId: string) {
  const tuple = useTriageReasonsWidgetQuery({
    variables: {
      storeId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        formState: {
          triageReasons: _.map(tuple.data?.store?.triageReasons ?? [], (reason): types.ITriageReason => ({
            id: reason.id,
            reasonText: reason.reasonText
          }))
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useSaveTriageReasons(storeId: string) {
  const [fnMutate, tuple] = useSaveTriageReasonsMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState) => {
      await fnMutate({
        variables: {
          input: {
            storeId,
            reasons: _.map(formState.triageReasons, reason => reason.reasonText)
          }
        }
      });
    },
    [
      storeId,
      fnMutate
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
